export default __webpack_public_path__ + "static/media/produto-doce-de-leite.94e638f9.png";